export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_51-a7dd9a3887386bc40dffcc0d399d9421.jpg";